
import { motion } from 'framer-motion';

export default function AdvertiseHero() {
  return (
    <section className="relative h-screen w-full overflow-hidden flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e32400453f3c42b62a3af8a575106b57.jpg"
          alt="Las Vegas Billboard Advertising"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 py-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <span className="inline-block px-3 py-1.5 bg-electric-blue/20 backdrop-blur-sm text-electric-blue rounded-full text-xs font-medium mb-4">
            For Advertisers
          </span>
          <h1 className="text-3xl md:text-5xl font-black text-white mb-4 leading-tight">
            Advertise in
            <br />
            <span className="bg-gradient-to-r from-electric-blue to-cyan-400 bg-clip-text text-transparent">
              Las Vegas
            </span>
            ,
            <br />
            Where the World Watches
          </h1>
          <p className="text-base text-gray-300 mb-6 leading-relaxed">
            Put your brand in front of 42 million annual visitors
            <br className="hidden md:block" />
            in one of the world&apos;s most iconic destinations — 24/7, 365 days a year.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="#inquiry-form"
              className="px-6 py-2.5 bg-gradient-to-r from-electric-blue to-cyan-400 text-white rounded-full font-medium text-sm hover:shadow-[0_0_30px_rgba(0,212,255,0.6)] transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              Book a Free Consultation
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#plans"
              className="px-6 py-2.5 bg-white/10 backdrop-blur-sm border border-white/30 text-white rounded-full font-medium text-sm hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              View Pricing Plans
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
